import { render } from "./PerformanceOverview.vue?vue&type=template&id=b31711a4&scoped=true"
import script from "./PerformanceOverview.vue?vue&type=script&lang=js"
export * from "./PerformanceOverview.vue?vue&type=script&lang=js"

import "./PerformanceOverview.vue?vue&type=style&index=0&id=b31711a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31711a4"]])

export default __exports__